import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Button } from "@mui/material";
import CustomModal from "../../../../common-utilities/core/modal";

export const toShipToList = (value) =>
  (Array.isArray(value) ? value : `${value ?? ""}`.split("\n"))
    .map((address) => `${address ?? ""}`.trim())
    .filter(Boolean);

export const toShipToExcelValue = (value) => {
  const list = toShipToList(value);
  return list.length ? list.join("\n") : null;
};

const ShipToCell = ({ addresses, prNumber }) => {
  const [open, setOpen] = useState(false);
  const list = toShipToList(addresses);

  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open]);

  if (!list.length) return "-";
  if (list.length === 1) return list[0];

  return (
    <span onClick={(e) => e.stopPropagation()}>
      {list[0]}{" "}
      <Button
        variant="text"
        size="small"
        sx={{ textTransform: "none", fontWeight: 600, padding: 0, minWidth: 0 }}
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
      >
        +{list.length - 1} more
      </Button>
      {open &&
        createPortal(
          <CustomModal
            title={prNumber ? `Ship to - ${prNumber}` : "Ship to"}
            onClose={() => setOpen(false)}
          >
            <div style={{ textAlign: "left", minWidth: 280, maxWidth: 520 }}>
              {list.map((address, index) => (
                <div
                  key={`${index}-${address}`}
                  style={{
                    padding: "6px 0",
                    whiteSpace: "normal",
                    overflowWrap: "anywhere",
                    borderBottom:
                      index < list.length - 1 ? "1px solid #eee" : "none",
                  }}
                >
                  {address}
                </div>
              ))}
            </div>
          </CustomModal>,
          document.body
        )}
    </span>
  );
};

export default ShipToCell;
